import React, { useCallback, useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBagIcon, MapPinIcon } from 'lucide-react';
const NAMES = ['María', 'Camila', 'Valentina', 'Lucía', 'Sofía', 'Martina', 'Florencia', 'Agustina', 'Julieta', 'Carolina', 'Romina', 'Daniela', 'Milagros', 'Rocío', 'Belén', 'Celeste', 'Natalia', 'Guadalupe', 'Pilar', 'Antonella', 'Paula', 'Micaela', 'Aldana', 'Brenda', 'Yanina', 'Soledad', 'Andrea', 'Lorena', 'Silvina', 'Mariana'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Tucumán', 'La Plata', 'Mar del Plata', 'Salta', 'Santa Fe', 'Neuquén', 'Bahía Blanca', 'Resistencia', 'Posadas', 'San Juan', 'Paraná', 'San Luis', 'Corrientes', 'Bariloche', 'Quilmes', 'Lanús', 'Morón', 'San Isidro', 'Tigre', 'Pilar', 'Tandil', 'Junín', 'Rafaela', 'Villa María', 'Río Cuarto', 'Ushuaia'];
function getRandom<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
function getRandomMinutes(): number {
  return Math.floor(Math.random() * 45) + 2;
}
export function SalesNotification() {
  const [visible, setVisible] = useState(false);
  const [notification, setNotification] = useState({
    name: '',
    city: '',
    minutes: 0
  });
  const showNotification = useCallback(() => {
    setNotification({
      name: getRandom(NAMES),
      city: getRandom(CITIES),
      minutes: getRandomMinutes()
    });
    setVisible(true);
    setTimeout(() => {
      setVisible(false);
    }, 4500);
  }, []);
  useEffect(() => {
    // Show first notification after 8 seconds
    const initialTimeout = setTimeout(() => {
      showNotification();
    }, 8000);
    // Then every 25 seconds
    const interval = setInterval(() => {
      showNotification();
    }, 25000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, [showNotification]);
  return <div className="fixed bottom-4 left-4 z-50 max-w-[340px]" data-id="element-123">
      <AnimatePresence data-id="element-124">
        {visible && <motion.div initial={{
        opacity: 0,
        x: -80,
        scale: 0.9
      }} animate={{
        opacity: 1,
        x: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        x: -80,
        scale: 0.9
      }} transition={{
        type: 'spring',
        damping: 25,
        stiffness: 300
      }} className="bg-white rounded-2xl shadow-xl border border-sage/15 p-4 flex items-start gap-3 cursor-default" data-id="element-125">
            {/* Icon */}
            <div className="w-10 h-10 rounded-full bg-lightSage flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-126">
              <ShoppingBagIcon className="w-5 h-5 text-sage" data-id="element-127" />
            </div>

            {/* Content */}
            <div className="min-w-0" data-id="element-128">
              <p className="text-sm font-semibold text-brown leading-snug" data-id="element-129">
                {notification.name} compró el Plan
              </p>
              <div className="flex items-center gap-1 mt-1" data-id="element-130">
                <MapPinIcon className="w-3.5 h-3.5 text-terracotta flex-shrink-0" data-id="element-131" />
                <span className="text-xs text-brown/60 truncate" data-id="element-132">
                  {notification.city}, Argentina
                </span>
              </div>
              <p className="text-xs text-brown/40 mt-1" data-id="element-133">
                hace {notification.minutes} minutos
              </p>
            </div>

            {/* Subtle progress bar that shows how long the notification stays */}
            <motion.div className="absolute bottom-0 left-0 h-0.5 bg-sage/30 rounded-b-2xl" initial={{
          width: '100%'
        }} animate={{
          width: '0%'
        }} transition={{
          duration: 4.5,
          ease: 'linear'
        }} data-id="element-134" />
          </motion.div>}
      </AnimatePresence>
    </div>;
}